export const DocumentKeys = {
	all: ["document"] as const,
	get allLists() {
		return [...this.all, "list"] as const;
	},
	list: (tag?: string) => [...DocumentKeys.allLists, { tag }] as const,
	download: (id: number) => [...DocumentKeys.all, "download", id] as const,
	get transfer() {
		return [...this.all, "transfer"] as const;
	},
};
